import { Liquor } from "./liquor";
import { ListAlt } from "./list_alt";
import { LiveHelp } from "./live_help";
import { LiveTv } from "./live_tv";
import { LocalCafe } from "./local_cafe";
import { LocalFireDepartment } from "./local_fire_department";
import { LocalShipping } from "./local_shipping";
import { LocationCity } from "./location_city";
import { LocationOn } from "./location_on";
import { Luggage } from "./luggage";

const iconsList = [
  { label: "Liquor", code: <Liquor /> },
  { label: "ListAlt", code: <ListAlt /> },
  { label: "LiveHelp", code: <LiveHelp /> },
  { label: "LiveTv", code: <LiveTv /> },
  { label: "LocalCafe", code: <LocalCafe /> },
  { label: "LocalFireDepartment", code: <LocalFireDepartment /> },
  { label: "LocalShipping", code: <LocalShipping /> },
  { label: "LocationCity", code: <LocationCity /> },
  { label: "LocationOn", code: <LocationOn /> },
  { label: "Luggage", code: <Luggage /> },
];

export {
  iconsList,
  Liquor,
  ListAlt,
  LiveHelp,
  LiveTv,
  LocalCafe,
  LocalFireDepartment,
  LocalShipping,
  LocationCity,
  LocationOn,
  Luggage,
};
